import request from '@/router/axios';
//主接线图二版
export const topologymainwiringdiagram = (data) => {
  return request({
    url: '/bma-old-ess-service/svoltcloudapi/energymanage/energymanage/main/topology/mainWiringDiagram',
    method: 'post',
    params: data
  })
}
//集装箱内部设备菜单接口-切换
export const equipmentchildren = (data) => {
  return request({
    url: '/bma-old-ess-service/svoltcloudapi/energymanage/energymanage/main/build/equipmentchildren',
    method: 'post',
    data: data
  })
}
//遥信遥测
export const equipmentfieldswithdatatype = (data) => {
  return request({
    url: '/bma-old-ess-service/svoltcloudapi/energymanage/energymanage/main/build/equipmentfieldswithdatatype',
    method: 'post',
    data: data
  })
}
//遥调接口
export const invokegrid = (data) => {
  return request({
    url: '/bma-old-ess-service/svoltcloudapi/energymanage/energymanage/main/project/invokegrid',
    method: 'post',
    data: data
  })
}
//策略列表
export const getStrategyList = (data) => {
  return request({
    url: '/bma-old-ess-service/svoltcloudapi/energymanage/energymanage/main/project/getStrategyList',
    method: 'post',
    data: data
  })
}
//日充电量
export const charginganddischargingwithsumdaily = (data) => {
  return request({
    url: '/bma-old-ess-service/svoltcloudapi/energymanage/energymanage/main/statistics/charginganddischargingwithsumdaily',
    method: 'post',
    data: data
  })
}
//根据项目编号获取一级接线图页签
export const primaryWiringDiagramTab = (data) => {
  return request({
    url: '/svolt-ess-service/monitor/topology/primaryWiringDiagramTab',
    method: 'post',
    data: data
  })
}
//根据页签编号获取接线图
export const wiringDiagram = (data) => {
  return request({
    url: '/svolt-ess-service/monitor/topology/wiringDiagram',
    method: 'post',
    data: data
  })
}
//获取设备模板下属设备列表切换页签-new
export const equipmentListByTemplateId = (data) => {
  return request({
    url: '/svolt-ess-service/monitor/topology/equipmentListByTemplateId',
    method: 'post',
    data: data
  })
}
//获取设备遥信遥测遥调数据-new
export const equipmentFieldsListByEquipIdAndDataType = (data) => {
  return request({
    url: '/svolt-ess-service/monitor/topology/equipmentFieldsListByEquipIdAndDataType',
    method: 'post',
    data: data
  })
}

//获取设备遥信遥测遥调数据
export const invokeGrid = (data) => {
  return request({
    url: '/svolt-ess-service/monitor/topology/invokeGrid',
    method: 'post',
    data: data
  })
}

//获取设备遥信遥测遥调数据
export const getInvokeGridResult = (data) => {
  return request({
    url: '/svolt-ess-service/monitor/topology/getInvokeGridResult',
    method: 'post',
    data: data
  })
}

//根据当前的组织id搜索项目列表
export const searchProjects = (data) => {
  return request({
    url: '/svolt-ess-service/groupMain/searchProjects',
    method: 'post',
    data: data
  })
}
//电表接线图
export const buildLoadEquipmentTreeWithFields = () => {
  return request({
    url: '/energymanage/energymanage/main/project/build/buildLoadEquipmentTreeWithFields',
    method: 'get',
    params: 'data'
  })
}
export default {
  topologymainwiringdiagram,
  equipmentchildren,
  equipmentfieldswithdatatype,
  invokegrid,
  getStrategyList,
  charginganddischargingwithsumdaily,
  primaryWiringDiagramTab,//新版
  wiringDiagram,
  equipmentListByTemplateId,
  equipmentFieldsListByEquipIdAndDataType,
  invokeGrid,
  getInvokeGridResult,
  searchProjects,
  buildLoadEquipmentTreeWithFields
}



// WEBPACK FOOTER //
// ./src/api/svolt/wiring-diagram.js